@for (casePreview of casePreviews$ | async; track casePreview) { @if (isCasePreview(casePreview)) {
<section class="mat-elevation-z2 case-card">
  <h2>
    Affaire @if (casePreview.url) {
    <sibat-link-button
      [label]="casePreview.friacFolderNumber"
      [external]="true"
      [href]="casePreview.url"
      target="_blank"
    ></sibat-link-button>
    } @if (!casePreview.url) {
    <span>{{ casePreview.friacFolderNumber }}</span>
    }
  </h2>
  <h3>Adresses concernées</h3>
  <ul>
    @for (address of casePreview.addresses; track address) {
    <li>
      {{ address }}
    </li>
    }
  </ul>
  <h3>Bâtiments concernés</h3>
  <ul>
    @for (building of casePreview.buildings; track building) {
    <li>
      <a [routerLink]="['/building', building.id]">{{ building.addresses[0] || 'Adresse à vérifier' }}</a>
      @if (building.urlSharePoint) {
      <sibat-link-button label="SharePoint" [external]="true" [href]="building.urlSharePoint" target="_blank"></sibat-link-button>
      }
    </li>
    }
  </ul>
  <p>Circulation en cours: {{ casePreview.recirculationIteration }}</p>
  @if (casePreview.linkedCases.length) {
  <p>Affaires liées :</p>
  <ul>
    @for (linkedCase of casePreview.linkedCases; track linkedCase) {
    <li>
      <sibat-link-button
        [label]="linkedCase.friacFolderNumber"
        [href]="'case/' + linkedCase.friacFolderNumber"
        data-testid="linked-case-number"
      >
      </sibat-link-button
      >&nbsp; @if (linkedCase.url) {
      <sibat-link-button
        label="SharePoint"
        [external]="true"
        [href]="linkedCase.url"
        target="_blank"
        data-testid="linked-case-link"
      ></sibat-link-button>
      }
    </li>
    }
  </ul>
  }
</section>
} @if (isControlCasePreview(casePreview)) {
<section class="mat-elevation-z2 case-card">
  <h2>Contrôle</h2>
  <ul>
    <li>
      {{ formatDateLabelTimestamp(casePreview.date) }}
      {{ casePreview.finalizedAt ? ' - ' + formatDateLabelTimestamp(casePreview.finalizedAt) : '' }}
    </li>
    <li>
      {{ casePreview.userFullName }}
    </li>
    <li>
      {{ casePreview.status }}
    </li>
  </ul>
</section>
} @if (isAssessmentCasePreview(casePreview)) {
<section class="mat-elevation-z2 case-card">
  <h2>Evaluation</h2>
  <ul>
    <li>
      {{ formatDateLabelTimestamp(casePreview.date) }}
      {{ casePreview.finalizedAt ? ' - ' + formatDateLabelTimestamp(casePreview.finalizedAt) : '' }}
    </li>
    <li>
      {{ casePreview.userFullName }}
    </li>
    <li>
      {{ casePreview.status }}
    </li>
  </ul>
</section>
} }
